<template>
  <div class="mt-3 mt-md-4">
    <label :for="`room-select-${cartItem.id}`" class="font-size-sm font-weight-bold color-text-dark">
      {{ i18n.chooseRoomLayout }}
    </label>

    <div class="room-select mt-2">
      <div class="room-select__select">
        <select
          :id="`room-select-${cartItem.id}`"
          @change="onRoomSelect"
          v-model="selectedRoom"
        >
          <option value="">
            {{ i18n.chooseRoomLayout }}
          </option>

          <option
            v-for="(title, key) in rooms"
            :key="`${cartItem.id}-${key}`"
            :value="key"
          >
            {{ title }}
          </option>
        </select>

        <Icon name="arrow-down" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rooms: this.cartItem.rooms,
      selectedRoom: this.cartItem.selectedRoom || '',
    };
  },

  mounted() {
    if (this.selectedRoom) {
      this.onRoomSelect();
    }
  },

  methods: {
    ...mapActions([
      'getRoomOptions',
    ]),

    ...mapMutations([
      'setSelectedRoomForCartItem',
    ]),

    onRoomSelect() {
      this.setSelectedRoomForCartItem([this.cartItem.id, this.selectedRoom]);
      this.getRoomOptions([this.cartItem.id, this.selectedRoom]);
    },
  },
};
</script>
